import { render, staticRenderFns } from "./CreateVesselInvoice.vue?vue&type=template&id=2a15101c&scoped=true"
import script from "./CreateVesselInvoice.vue?vue&type=script&lang=js"
export * from "./CreateVesselInvoice.vue?vue&type=script&lang=js"
import style0 from "./CreateVesselInvoice.vue?vue&type=style&index=0&id=2a15101c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a15101c",
  null
  
)

export default component.exports